import { saveAs } from '../../../../node_modules/file-saver/dist/FileSaver';


export class AppCommonService {
  static downloadReport(arg0: any, arg1: any): any {
    throw new Error("Method not implemented.");
  }

  static downloadFile(reportData, extension) { 
    
    const data = this.base64ToArrayBuffer(reportData);
    const blob = new Blob([data], { type: "octet-stream" });
    const fileName = Math.floor(Date.now() / 1000) + extension;
    
    saveAs(blob, fileName);
  }

  static base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  static getFileExtension(fname) {
    let extension;
    const pos = fname.lastIndexOf(".");
    const strlen = fname.length;
    if (pos !== -1 && strlen !== pos + 1) {
      const ext = fname.split(".");
      const len = ext.length;
      extension = ext[len - 1].toLowerCase();
    } else {
      extension = null;
    }
    return extension;
  }
}

